import {
  computed,
  ref,
  toRef,
} from "vue";

import AMobileAPI from "aloha-vue/src/compositionAPI/AMobileAPI";
import PuxTablePlugin, {
  tablePluginOptions,
} from "../plugin/PuxTablePlugin";

export default function PreviewAPI(props, {
  puxTableRef = ref(undefined),
}) {
  const preview = toRef(props, "preview");

  const {
    asideFixedHeight,
    navbarFixedHeight,
  } = PuxTablePlugin.LayoutAPI();

  const {
    isMobileWidth,
  } = AMobileAPI();

  const previewStyles = computed(() => {
    if (preview.value === "right" &&
      tablePluginOptions.value.global.project === "proandi" &&
      !isMobileWidth.value) {
      if (navbarFixedHeight && asideFixedHeight) {
        return {
          top: `${ navbarFixedHeight.value }px`,
          height: `${ asideFixedHeight.value }px`,
        };
      }
    }

    return undefined;
  });

  const closePreviewAll = () => {
    puxTableRef.value?.closePreviewAll();
  };

  return {
    closePreviewAll,
    previewStyles,
  };
}
